import { useNavigate } from 'react-router-dom';
// import GuideList from '../../../guide-list/guide-list';
import GuideList from 'react-components/guide-list/guide-list';
import { Routes, SyncHook } from '../route-types';

export const GUIDE_PATH = '/guides';

const useSyncHook: SyncHook = null;

const routes: Routes = [
  {
    path: GUIDE_PATH,
    element: <GuideList />,
  },
];

const useNavigationHooks = () => {
  const navigate = useNavigate();
  return {
    toGuideList: () => {
      navigate(GUIDE_PATH);
    },
  };
};

export const guideListPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
